export const progressPercentage = ({
  currStep,
  totalSteps
}: {
  currStep: number
  totalSteps: number
}): number => (currStep / totalSteps) * 100
